export enum ContentType {
  HINT = 'hint',
  TEXT = 'text',
  ILLUSTRATION = 'illustration',
  SPACER = 'spacer',
}
